module.exports = __webpack_public_path__ + "img/p2_l.11fdaec3.jpg";